import { Link } from "react-router-dom";
import { Buildings, HardHat, UsersThree } from "@phosphor-icons/react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { usePageSeo } from "@/hooks/usePageSeo";
import { images } from "@/data/site";

const categories = [
  { icon: HardHat, title: "Skilled Mechanical Manpower", items: ["Mechanical Engineers & Supervisors", "Mechanical Foremen", "Fabricators", "Fitters", "Welders", "Riggers", "Equipment Operators"] },
  { icon: Buildings, title: "Civil Manpower", items: ["Civil Engineers", "Civil Supervisors", "Masons", "Carpenters", "Bar Benders", "Civil Helpers"] },
  { icon: UsersThree, title: "Supporting Staff", items: ["Cooks", "Office Boys", "Housekeeping Staff", "Sweepers", "General Helpers"] },
];

export default function ManpowerPage() {
  usePageSeo({ title: "Manpower Supply PAN India | Shyam Equipment and Infratech", description: "Skilled mechanical, civil, and supporting manpower supply for industrial, refinery, EPC, infrastructure, and construction projects across India.", path: "/manpower" });
  return (
    <main className="text-industrial-text" data-testid="manpower-page">
      <Header />
      <PageHero eyebrow="Manpower Solutions" title="Skilled teams aligned to your project schedule" description="Short-term and long-term manpower support for mechanical, civil, and site operations, backed by responsive mobilization." image={images.manpower} imageAlt="Industrial engineers at a refinery" primaryLabel="Request Manpower" testId="manpower-page-hero" />
      <section className="py-20 sm:py-24" data-testid="manpower-detail-categories">
        <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
          <div className="mb-10 max-w-3xl">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.28em] text-industrial-yellow">Deployment Categories</p>
            <h2 className="mt-4 font-heading text-3xl font-bold uppercase text-industrial-text sm:text-5xl">From certified specialists to dependable site support</h2>
          </div>
          <div className="grid gap-6 lg:grid-cols-3">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <article key={category.title} className="border border-industrial-line bg-industrial-surface p-6 transition-all hover:-translate-y-1 hover:hard-shadow-sm" data-testid={`manpower-page-category-${index + 1}`}>
                  <Icon size={40} weight="fill" className="text-industrial-yellow" />
                  <h3 className="mt-6 font-heading text-2xl font-semibold uppercase text-industrial-text">{category.title}</h3>
                  <ul className="mt-6 space-y-3">
                    {category.items.map((item) => <li key={item} className="flex gap-3 text-sm text-industrial-muted"><span className="mt-2 h-1.5 w-1.5 shrink-0 bg-industrial-yellow" />{item}</li>)}
                  </ul>
                </article>
              );
            })}
          </div>
          <div className="mt-10 border border-industrial-yellow bg-industrial-yellow p-7 text-industrial-black" data-testid="manpower-commercial-note">
            <p className="font-heading text-2xl font-semibold uppercase">Share role count, site location, duration, and joining timeline for a practical mobilization plan.</p>
            <Link to="/contact" data-testid="manpower-page-contact-link" className="mt-5 inline-flex border border-industrial-black px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em]">Send requirement</Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
